import { defineMessages } from 'react-intl-next';

export default defineMessages({
	followAiMateButton: {
		id: 'ai-mate.inline-chat-input.follow-button.label',
		defaultMessage: 'Follow',
		description: 'Label for the follow AI mate button',
	},
	stopGeneratingButtonLabel: {
		id: 'ai-mate.inline-chat-input.stop-generating-button.label',
		defaultMessage: 'Stop generating',
		description: 'Label for the stop generating button',
	},
	thinkingText: {
		id: 'ai-mate.inline-chat-input.thinking',
		defaultMessage: 'Rovo is analyzing',
		description: 'Text displayed when the assistant is processing a request.',
	},
	editingText: {
		id: 'ai-mate.inline-chat-input.editing',
		defaultMessage: 'Rovo is editing',
		description: 'Text displayed when the assistant is editing a request.',
	},
});
